import { render, staticRenderFns } from "./HeaderMain.vue?vue&type=template&id=871dbae4&"
import script from "./HeaderMain.vue?vue&type=script&lang=ts&"
export * from "./HeaderMain.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports